/**
 * API Endpoints for Jobs feature
 * Names match service methods (screaming architecture)
 */
const BASE = "/jobs";

export const JOBS_ENDPOINTS = {
  GET_JOBS: BASE,
  GET_JOB: (id: string) => `${BASE}/${id}`,
  CREATE_JOB: BASE,
  DELETE_JOB: (id: string) => `${BASE}/${id}`,
  CANCEL_JOB: (id: string) => `${BASE}/${id}/cancel`,
  CREATE_VOUCHER_ORDER: "/voucher_orders",
} as const;
